import { EMetaType } from './types';

export const EMetaTypeDesMap:Record<EMetaType, string> = {
    [EMetaType.LANDMARKS]: 'Nearby landmarks',
    [EMetaType.CITIES]: 'Cities',
    [EMetaType.COUNTIES]: 'Counties',
    [EMetaType.ZIP]: 'ZIP codes',
};
